export type TaskDateKind = 'planned' | 'due' | 'both';

export function boardStatusForColumn(column: string) {
  if (column === 'doing') return 'doing';
  if (column === 'review') return 'review';
  if (column === 'done') return 'done';
  return 'todo';
}

export function taskDatePatch(kind: TaskDateKind, date: string) {
  if (kind === 'both') return { plannedDate: date, dueDate: date };
  return kind === 'due' ? { dueDate: date } : { plannedDate: date };
}

export function reorderTaskItems<T extends { id: number }>(
  items: T[],
  draggedId: number,
  targetId: number | null,
  placeAfter = false,
) {
  if (targetId === draggedId) return items;
  const dragged = items.find((item) => item.id === draggedId);
  if (!dragged) return items;
  const remaining = items.filter((item) => item.id !== draggedId);
  if (targetId === null) return [...remaining, dragged];
  const targetIndex = remaining.findIndex((item) => item.id === targetId);
  if (targetIndex < 0) return items;
  const insertionIndex = targetIndex + (placeAfter ? 1 : 0);
  return [...remaining.slice(0, insertionIndex), dragged, ...remaining.slice(insertionIndex)];
}
